<div style="display: flex;flex-direction: column;align-items: center;
justify-content: center;flex:1;align-self: center;">



  <mat-card style="margin-top: 25px;margin-left: 2%;margin-right: 2%;">

    <div *ngIf="Loading==true" style="display: flex;flex-direction: column;align-items: center; justify-content: center;min-height: 500px;align-self: center;position: absolute;
    margin-left: 43%;">
      <mat-spinner></mat-spinner>
    </div>
    <!-- <div style="justify-content: center;align-self: center;margin-top: 2%;"> -->
      <span *ngIf="DocumentId == 0" style="font-size: 25px;">{{'Add Document in Library' | translate | async}}</span>
    <span *ngIf="DocumentId > 0" style="font-size: 25px;">{{'Edit Document in Library' | translate | async}}</span>   
      <button  style="float: right;" class="button button--primary"><span class="button__text"
        (click)="NavigateToSearch()">{{'Return to Search Screen' | translate | async}}</span></button>

    <!-- </div> -->
    <div class="search-options"
      style="min-width: 150px;width: 100%;display: flex;justify-content: space-between;flex-wrap: wrap;height: 400px;">
     
      <mat-form-field style="margin-left: 0px">
        <mat-select placeholder="Select Build #"  [formControl]="buildnoFormControl" [(ngModel)]="Selectmodel" multiple required>
           <mat-option (click)="selectAll(ev)"    [value]="0"
        #ev
         >{{'Select All' | translate | async}}</mat-option>
          <mat-option *ngFor="let model of modelList"  [value]="model.ID" (click)="valueChange(model.ID)">{{model.modelName}}</mat-option>
        
        </mat-select>
        <mat-error *ngIf="buildnoFormControl.invalid">{{getErrorMessage()}}</mat-error>
      </mat-form-field>

   


      <mat-form-field class="header-form-full-width">
        <mat-label>{{'Enter Serial # Start' | translate | async}}</mat-label>
        <input type="text"    matInput placeholder="{{'Enter Serial # Start' | translate | async}}" [(ngModel)]="serialStart"  class="ng-pristine ng-invalid ng-invalid-required ng-touched">
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <mat-label>{{'Enter Serial # End' | translate | async}}</mat-label>
        <input type="text"  matInput placeholder="{{'Enter Serial # End' | translate | async}}" [(ngModel)]="serialEnd" >
      </mat-form-field>




      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'Select Doc. Type' | translate | async}}" [(ngModel)]="docTypeID" required>
          <mat-option [value]="type.ID" *ngFor="let type of docTypeList">{{type.DocType}}</mat-option>
        </mat-select>
      </mat-form-field>


      <!-- <mat-form-field class="header-form-full-width">
        <mat-label>Enter Doc. Heading</mat-label>
        <input type="text" matInput placeholder="Enter Doc. Heading" [(ngModel)]="docHeading" >
      </mat-form-field> -->

   

      <!-- <mat-form-field class="header-form-full-width">
        <mat-label>Enter Doc. #</mat-label>
        <input type="text" matInput placeholder="Enter Doc. #" [(ngModel)]="docNumber" required>
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <mat-label>Enter Doc. Rev#</mat-label>
        <input type="text" matInput placeholder="Enter Doc. Rev#" [(ngModel)]="docRev" required>
      </mat-form-field> -->



      <mat-form-field class="header-form-full-width">
        <mat-select placeholder="{{'Select Doc. Status' | translate | async}}" [(ngModel)]="docStatus" required>
          <mat-option [value]="status.ID" *ngFor="let status of docStatusList">{{status.DocStatus}}</mat-option>

        </mat-select>
      </mat-form-field>
      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>



      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pickerStart" [(ngModel)]="startDate" >
        <mat-placeholder>{{'Select Start Date' | translate | async}}</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
        <mat-datepicker #pickerStart></mat-datepicker>
      </mat-form-field>


      <mat-form-field class="header-form-full-width">
        <input matInput [matDatepicker]="pickerEnd" [(ngModel)]="endDate" >
        <mat-placeholder>{{'Select End Date' | translate | async}}</mat-placeholder>
        <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd></mat-datepicker>
      </mat-form-field>






      <mat-form-field class="header-form-full-width invisible">
        <mat-select name="customer" class="invisible">
        </mat-select>
      </mat-form-field>


      <div style="display: flex;min-width: 30%;height:40px">
       
        <span style="cursor: pointer;font-size: 17px;">{{'Attach Doc.' | translate | async}}</span>
          <div *ngFor="let form of attachmentList, let i =  index" style="display: flex;height:40px;justify-content: left;">
            <i style="cursor: pointer;vertical-align: bottom; margin-left: 2%;font-size: 40px;
            color: #3da14b;"
              class="material-icons" class="material-icons" (click)="onClickDownloadForm(form, i)">description</i>
              <span style="cursor: pointer;font-size: 13px; max-width: 10em;    overflow-wrap: break-word;">{{form.FileName}}</span>
            <span style=" max-width: 10em; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"><i class="material-icons sc-icon" (click) ="delete(i)">delete</i></span>
          </div>
         
          <i   class="material-icons" (click)="openAttachDoc()" style="cursor: pointer;vertical-align: bottom; margin-left: 2%; ">add</i>
          <!-- <div *ngFor="let f of filearr" style="display: flex;height:40px;justify-content: left;">
            <i style="cursor: pointer;vertical-align: bottom; margin-left: 2%;" class="material-icons">description</i>
        </div> -->
      </div>


      <div style="display: flex;min-width: 30%;height:40px">
         <mat-checkbox class="example-margin" [(ngModel)]="assetAdded"  (change)="ChangeCheckbox($event)" >{{'Automatically Add to Assets defined by above selection criteria' | translate | async}}</mat-checkbox>
      </div>

      <!-- <div style="min-width: 30%;width: 30%;"></div> -->



      <div style="display: flex;flex-direction: row;justify-content: flex-end;align-self: flex-end;">
        <!-- <button  style="margin-left: 20px;" class="button button--primary"><span class="button__text"
          (click)="NavigateToSearch()">Return to Search Screen</span></button> -->
          <button style="margin-left: 20px;" class="button button--primary" (click)="confirmReset()" ><span
            class="button__text">{{'Reset' | translate | async}}</span></button>

        <button  *ngIf="DocumentId == 0" style="margin-left: 20px;" class="button button--primary" ><span class="button__text"
            (click)="addNewDocumentLibrary()">{{'Save' | translate | async}}</span></button>

        <button *ngIf="DocumentId > 0" style="margin-left: 20px;" class="button button--primary"><span class="button__text"
            (click)="updateNewDocumentLibrary()">{{'Update' | translate | async}}</span></button>
      </div>

    </div>

  </mat-card>


  <div *ngIf="DocumentId > 0" style="width: 100%;">
    <div style="display: flex;min-width: 30%;height:40px; margin-top: 1%;">
      <span style="cursor: pointer;font-size: 17px;margin-left: 2%;">
      </span>

    </div>

    <table class="table table--full-width table--striped" style="margin-top: 9px;">

      <thead>
        <tr>
          <th style="display: flex;flex-direction: row;justify-content: space-between;">
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Date' | translate | async}}</span>

            </div>
            <!-- <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">Time</span>
            </div> -->
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Action' | translate | async}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'User' | translate | async}}
              </span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'Field Changed' | translate | async}}
              </span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'From' | translate | async}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{'To' | translate | async}}</span>
            </div>


          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let audit of auditTrailList">
          <td style="min-width: 50px;display: flex;flex-direction: row;justify-content: space-between;">

            <!-- <div style="display: flex;flex: 1;justify-content: center;">
                <span 
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{sr.CompletedDate | date:'dd MMM yyyy'}}</span>
              </div> -->
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.ModifiedDate
                | date:'dd MMM yyyy'}}</span>
            </div>
            <!-- <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;"></span>
            </div> -->
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.Action}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.ModifiedUserName}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.FieldName}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.OldValue}}</span>
            </div>
            <div style="display: flex;flex: 1;justify-content: center;">
              <span
                style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;">{{audit.NewValue}}</span>
            </div>
            <!-- <div style="display: flex;flex: 1;justify-content: center;">
                <span
                  style="cursor: pointer;min-width: 50px;display: flex;flex-direction: row;align-items: center;justify-content: center;"
                  class="material-icons-outlined">
                  <i *ngIf="sr.IsDigitalForm == true" class="material-icons">dynamic_form</i>
                  <i (click)="onClickDownloadForm(sr)" *ngIf="sr.IsDigitalForm != true"
                    class="material-icons">picture_as_pdf</i>
                </span>
              </div> -->

          </td>
        </tr>
      </tbody>
    </table>

    

  </div>



</div>